import React from "react";
import SEO from "../../Hook/Seo";
import BreadcrumbsSchema from "../../Hook/BreadcrumbsSchema";
function NotFound() {
    return (
        <>
            <SEO
                title="Page non trouvée – AM Services"
                description="La page demandée n’existe pas ou a été déplacée."
                path="/404"
                noindex
            />
            <BreadcrumbsSchema />
            <div style={{ textAlign: "center", marginTop: "50px" }}>
                <h1>404</h1>
                <p>Oups ! Cette page n’existe pas.</p>
            </div></>
    );
}

export default NotFound;
